var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgDocumentDollar = function SvgDocumentDollar(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.75571 11.2861V7.35756C8.75571 6.94079 8.92127 6.54109 9.21597 6.24639C9.51067 5.95169 9.91037 5.78613 10.3271 5.78613H18.1843L26.0414 13.6433V24.6433C26.0414 25.06 25.8759 25.4597 25.5812 25.7544C25.2865 26.0491 24.8868 26.2147 24.47 26.2147H18.97",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1843 5.78613V13.6433H26.0414",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0906 23.7742C10.3323 24.0583 10.6365 24.2838 10.9799 24.4334C11.3232 24.583 11.6966 24.6527 12.0714 24.6372C12.6443 24.6759 13.21 24.4931 13.6496 24.1273C14.0891 23.7615 14.3684 23.2412 14.4286 22.6758C14.3684 22.1104 14.0891 21.5901 13.6496 21.2243C13.21 20.8585 12.6443 20.6757 12.0714 20.7144C11.4986 20.7531 10.9329 20.5703 10.4933 20.2045C10.0537 19.8387 9.77448 19.3184 9.71429 18.753C9.76965 18.1856 10.0475 17.6623 10.4883 17.2955C10.929 16.9288 11.4974 16.7478 12.0714 16.7916C12.4396 16.7693 12.8083 16.8281 13.1508 16.9637C13.4933 17.0994 13.8011 17.3085 14.0522 17.5761",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9222 24.6426V26.214",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9222 15.2139V16.7853",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgDocumentDollar);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/document-dollar.e8d940dd996fcb252b088668beabe7f0.svg";